import { getMemberSettings } from "@utils/member-settings";
import { themeColorPresets, themePurpleStardust } from "kz-ui-sdk";
/**
 * Get the theme color configuration based on the brand key
 */
export const getThemeColorConfig = (themeId?: string) => {
  const themePresetKey = themeId || getMemberSettings()?.themeId || themePurpleStardust.id;
  return themeColorPresets[themePresetKey];
};

/**
 * Get the theme asset path based on the theme color configuration
 * Asset path should be relative to the theme folder
 * Examples
 * - mode: "THEME_DIR"
 * + Path "/images/logo.png" returns "/images/gold/logo.png"
 * + Path "/logo.png" returns "/images/gold/logo.png"
 * - mode: "CURRENT_DIR"
 * + Path "/images/logo.png" returns "/images/logo--theme-gold.png"
 * + Path "/logo.png" returns "/images/logo--theme-gold.png"
 * @param assetPath
 */
export const getThemeAsset = (assetPath: string, mode: "THEME_DIR" | "CURRENT_DIR" = "THEME_DIR") => {
  const themeConfig = getThemeColorConfig();
  // standardize the asset path
  // remove leading slash
  // remove /images/ prefix if exists
  assetPath = assetPath.startsWith("/") ? assetPath.slice(1) : assetPath;
  assetPath = assetPath.startsWith("images/") ? assetPath.slice(7) : assetPath;

  // return the asset path with the theme directory
  if (mode === "THEME_DIR") {
    return `/images/themes/${themeConfig.id}/${assetPath}`;
  }

  // return the asset path with the current directory
  const nameChunks = assetPath.split(".");
  const extension = nameChunks[nameChunks.length - 1];
  const fileName = nameChunks.slice(0, -1).join(".");
  return `/images/${fileName}--theme-${themeConfig.id}.${extension}`;
};
